export default "__VITE_ASSET__3cd474ff__"